import * as React from 'react'
import {View} from './View'
import {Main} from '../Logic/Main'
import Fantasy from './Main/Index/Fantasy'
import { BrowserRouter } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'

function getTime() {

    var now = new Date()
    var time = now.getTime()
    time += 3600000
    return time
}
function setCookies () {

    if( Main.Instance.Login &&
        Main.Instance.Location &&
        Main.Instance.Login.Username &&
        Main.Instance.Login.Mail) {
            document.cookie = 'username=' + Main.Instance.Login.Username
            document.cookie = 'mail=' + Main.Instance.Login.Mail
            let location = Main.Instance.Location == '/index' ? '/index' : Main.Instance.Location
            document.cookie = 'location=' + location
            document.cookie = 'expires=' + getTime().toString()
        }
}

export function MainView(props: React.Props<{}>): View {
    setCookies ()
    // return(<div><div id = ""><Fantasy/></div></div>)
    return (
        <CookiesProvider>
            <BrowserRouter>
                <Fantasy/>
            </BrowserRouter>   
        </CookiesProvider>
    )
}





// WEBPACK FOOTER //
// ./src/Views/Main.tsx